import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const ContentWrapper = styled.div`
    color: ${({ theme }) => theme.colors.blue.toString()};
    border: 2px solid ${({ theme }) => theme.colors.blue.toString()};
    border-radius: 5px;
`;

const GridWrapper = styled.div`
    display: flex;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 40px;
`;

const GridItem = styled.div`
    width: 100%;
`;

export const ToggleMore = styled.div`
    margin: 20px 0;
    font-size: 1rem;
    text-decoration: underline;
    cursor: pointer;
`;

export const ProductDetails = styled.div`
    display: flex;
    flex-direction: column;
    font-family: var(--font-family-vito);
`;

export const ProductHeadlineWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 0;
    cursor: pointer;
    color: ${({ active, theme }) =>
        active ? theme.colors.white.toString() : theme.colors.blue.toString()};
    background-color: ${({ active, theme }) =>
        active ? theme.colors.red.toString() : theme.colors.grey.toString()};
`;

export const ProductPrice = styled.div`
    font-size: 2rem;
    font-weight: 900;
    display: none;

    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: flex;
    `}
`;

export const ProductSubline = styled.div`
    display: flex;
    font-size: 1rem;
    padding: 0 20px;
`;

export const ProductName = styled.div`
    display: flex;
    font-weight: 900;
    font-size: 2rem;
    line-height: 1.9rem;
    text-align: center;
    ${({ theme }) => theme.breakpoints.from.small.css`
        font-size: 1.2rem;
        line-height: 1.8rem;
    `}

    ${({ theme }) => theme.breakpoints.from.medium.css`
        font-size: 1.25rem;
        line-height: 1.8rem;
    `}

    ${({ theme }) => theme.breakpoints.from.large.css`
        font-size: 1.5rem;
        line-height: 1.8rem;
    `}
`;

export const ProductInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

export const ProductRow = styled.div`
    display: flex;
    width: 100%;
    padding-top: 2px;
    padding-bottom: 2px;
`;

export const ProductReductionPlaceholder = styled.div`
    width: 100%;
    height: 38px;
`;

export const ProductRowLabel = styled.div`
    display: flex;
    width: 50%;
`;

export const ProductRowValue = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: 500;
`;

export const ProductRowValueOnly = styled.div`
    display: block;
`;

export const ProductRowValueAddition = styled.span`
    white-space: nowrap;
`;

export const PriceLabel = styled.div`
    display: flex;
    width: 50%;
    margin-top: 10px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        width: fit-content;
    `}
    ${({ theme }) => theme.breakpoints.from.normal.css`
        width: 50%;
    `}
`;

export const PriceValue = styled.div`
    display: flex;
    margin-top: 10px;
`;

export const isTotal = css`
    font-size: 1.2rem;
    font-weight: 500;
`;

export const isOldPrice = css`
    text-decoration: line-through;
`;

export const isReduction = ({ theme }) => css`
    color: ${theme.colors.red.toString()};
`;

export const adjustPriceActionMargin = css`
    margin-bottom: 100px;
`;

export const adjustButtonMargin = css`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const ExpandedContent = styled.div`
    width: 100%;
    margin-top: 0;
`;

const CalculatorProductDetails = ({ children, activeIndex }) => {
    const theme = useTheme();

    const inactiveColumn = css`
        ${theme.breakpoints.upTo.small.css`
            display: none !important;
        `}
    `;

    const borderRadiusActiveFixLeft = css`
        border-top-left-radius: 0;
        ${theme.breakpoints.from.medium.css`
             border-top-left-radius: 5px;
        `}
    `;

    const borderRadiusActiveFixRight = css`
        border-top-right-radius: 0;
        ${theme.breakpoints.from.medium.css`
             border-top-right-radius: 5px;
        `}
    `;

    const getCss = (activeIndex) => {
        if (activeIndex === 0) return borderRadiusActiveFixLeft;
        if (activeIndex === children.length - 1)
            return borderRadiusActiveFixRight;
    };

    return (
        <GridWrapper>
            {React.Children.map(children, (child, index) => {
                const isActiveElement = index === parseInt(activeIndex);
                return (
                    <GridItem
                        key={`product-${index}`}
                        css={!isActiveElement ? inactiveColumn : ""}
                    >
                        <ContentWrapper css={getCss(activeIndex)}>
                            {child}
                        </ContentWrapper>
                    </GridItem>
                );
            })}
        </GridWrapper>
    );
};

export default CalculatorProductDetails;
